import React from "react";

import { MessageEditorId } from "domains/message-component/reducer.types";

export type MessageEditorIdContextType = {
    id: MessageEditorId;
};

/**
 * Provides the unique id of the message editor being
 * updated, so that the compose actions can target that
 * specific message
 */
export const MessageEditorIdContext =
    React.createContext<MessageEditorIdContextType | null>(null);
